import { observable, makeObservable, runInAction } from "mobx";
import api from "../../api";
import { LogtoConfig } from "@logto/react";
import { message } from "antd";

class LoginStore {
  //搜索表单字段
  @observable companyList: any = [];
  @observable config: LogtoConfig = {
    endpoint: "",
    appId: "",
  };
  @observable redirectUrl: any = "";
  url:string ='';
  state = {};
  constructor() {
    makeObservable(this);
  }
  //sso登录
  toSSO() {
    window.location.href = `${window.location.origin}/api/oauth2/authorization/logto`;
  }

  async getOrgList() {
    await api.chooseCompanyApi
      .orgList()
      .then((res) => {
        runInAction(() => {
          this.companyList = res.data;
        });
      })
      .catch((error) => {});
  }

  //用户登录选择绑定企业id绑定企业信息
  async chooseOrganization(organizationId: string) {
    await api.chooseCompanyApi
      .chooseOrganization(organizationId)
      .then((res) => {})
      .catch((error) => {});
  }

  //JWT 授权登录
  async jwtLogin(idToken: any) {
    await api.loginApi
      .jwtLogin(idToken)
      .then((res) => {
        window.location.href = `${window.location.origin}/#/chooseCompany`;
      })
      .catch((error) => {
        //回到登录页展示错误提醒
        this.url = `${window.location.origin}/#/login`;
        this.state = {errMsg: error.msg};
        window.history.pushState(this.state, '', this.url);
        window.location.href = this.url
      });
  }
}

export default LoginStore;
